import React from "react";
import FAQAccordion from '../FAQAccordion';

class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
  }

 render() {
  return (
    <React.Fragment>
      <section id="info-eco-hiking-gear" className="about-us pt-trip gray-light-bg">
        <div className="container">
          <div className="row justify-content-center">
            <div>
              <div className="section-heading mb-5 mx-2">
                {this.props.showTitle && this.props.showTitle === true && (
                  <span className="badge badge-primary badge-pill">
                    Eco-Friendly Hiking Gear
                  </span>
                )}
                <h1 className="text-center">
                  How to Find Eco-Friendly Hiking Gear (Complete Beginner Guide)
                  <br />
                </h1>

                <p>
                  If you want to hike more sustainably, choosing eco-friendly hiking gear is one of the most important steps you can take.
                  The good news is that you do not need to replace everything you own.
                </p>

                <p>
                  You can start by making smarter choices when buying new gear and understanding what actually makes gear environmentally friendly.
                </p>

                <p>
                  In this guide, you will learn exactly how to find eco-friendly hiking gear, what materials to look for,
                  which brands to trust, and how to avoid greenwashing.
                </p>

                <p>
                  If you are planning your next hike, check out our guide on{" "}
                  <a className="in-text-link" href="/how-to-use-hiking-poles-correctly">
                    how to use hiking poles correctly
                  </a>{" "}
                  to improve your technique on the trail.
                </p>
                <FAQAccordion
                  title="Eco-Friendly Hiking Gear FAQs"
                  items={[
                    { q: 'What makes hiking gear eco-friendly?', a: 'Look for gear made from recycled materials (like recycled polyester from plastic bottles), certified organic or natural fibers, PFC-free water repellent treatments, and brands with transparent supply chains and repair programs.' },
                    { q: 'What certifications should I look for on sustainable hiking gear?', a: 'bluesign® certifies responsible fabric manufacturing. Fair Trade USA ensures ethical labor. GOTS (Global Organic Textile Standard) covers organic fibers. B Corp certification signals broader environmental commitments.' },
                    { q: 'What are the most eco-friendly hiking boot brands?', a: 'Danner, Keen, and Salomon have strong sustainability commitments. Look for boots made with recycled rubber outsoles, natural leather from Leather Working Group tanneries, or vegan uppers made from recycled materials.' },
                    { q: 'How do I avoid greenwashing when buying hiking gear?', a: 'Look for third-party certifications rather than self-reported claims. Check if the brand publishes a transparency report. Vague terms like "eco-conscious" or "green" without backing data are red flags.' },
                    { q: 'Is it better to buy second-hand hiking gear?', a: 'Yes — buying used gear is the most sustainable option. REI Co-op Used Gear, GearTrade, and eBay have good selections. Used gear is often barely worn and costs 30–70% less than new.' },
                    { q: 'What is the most sustainable way to care for hiking gear?', a: 'Wash gear less frequently, use cold water, air dry instead of tumble drying, and treat with PFC-free DWR spray to extend waterproofing. Repair rather than replace — most brands sell repair kits or offer in-store repairs.' },
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}
}
export default About;